import React from "react";

const Slogan = () => {
  return (
    <div className="sloganContainer">
      <h1 className="slogan">Wij Schoonmaken, U Ontspant</h1>
      <p className="sloganDescription">
        Wij begrijpen dat uw tijd kostbaar is. Terwijl wij uw ruimte grondig
        schoonmaken en verzorgen, kunt u ontspannen en genieten van uw vrije
        tijd. Ons toegewijde team staat voor u klaar, zodat u zich kunt
        concentreren op wat echt belangrijk is
      </p>
    </div>
  );
};

export default Slogan;
